function precise(num) {
  return Number(num).toFixed(2);
}

module.exports = precise;



// WEBPACK FOOTER //
// ./src/modules/precise.js